export default "__VITE_ASSET__vCPw9Fht__"